const toggleBtn = document.querySelectorAll('.faq-item')

const toggleContent = e => {
	const el = e.currentTarget.nextElementSibling
	const arrow = e.currentTarget.querySelector('svg')

	el.classList.toggle('max-h-[500px]')
	el.classList.toggle('pt-2')
	arrow.classList.toggle('rotate-90')
}
toggleBtn.forEach(btn => {
	btn.addEventListener('click', toggleContent)
})

// Trzeba nadać klasę `faq-item` na button do zwijania/rozwijania contentu. Następnie na ten kontener, który ma znikać  dać style/klasy css overflow-hidden oraz max-h-0 . Kontener powinien być w takiej hierarchii HTML = buttonDoKlikenia.parentElement.nextElementSibling - czyli powinien być rodzeństwem rodzica buttona do klikania. Wujkiem czy tam ciotką.
